import React from 'react';
import { Icon, S, XS } from 'design-system-web';
import cx from 'classnames';
import styles from './Pill.scss';

type PillProps = {
  text: string;
  size?: 'small' | 'medium';
  color: string;
  className?: string;
  iconName?: string;
  iconColor?: string;
};

export function Pill({
  size = 'small',
  color,
  text,
  className,
  iconName,
  iconColor,
}: PillProps) {
  return (
    <div className={cx(styles.container, className)}>
      <span className={styles.Pill} data-size={size} data-variant={color}>
        {iconName && (
          <Icon
            name={iconName}
            set="Feather"
            className={styles.icon}
            style={{
              fill: iconColor,
              color: iconColor,
            }}
          />
        )}
        {size === 'medium' ? (
          <S className={styles.medium}>{text}</S>
        ) : (
          <XS className={styles.small}>{text}</XS>
        )}
      </span>
    </div>
  );
}